import logUtil from 'utils/log'
import updateQuickShopHistoryProductsAction from 'modules/product/redux/actions/update-quick-shop-history'
import getQuickShopHistoryProductsSelect from 'modules/product/redux/selectors/get-quick-shop-history'
import getSelectedIndexMediaGallerySelect from 'modules/media-gallery/redux/selectors/get-selected-index'
import getSelectedColorOptionProductSelect from 'modules/variant/redux/selectors/get-selected-color-option'
import getSelectedColorVariantIdVariantSelect from 'modules/variant/redux/selectors/get-selected-color-variant-id'

const updateQuickShopHistorySelectedMediaAction = () => {
  return (dispatch, getState) => {
    const selectedMediaIndex = getSelectedIndexMediaGallerySelect(getState())
    const selectedColorOption = getSelectedColorOptionProductSelect(getState())
    const selectedColorVariantId = getSelectedColorVariantIdVariantSelect(getState())

    const logPrefix = `selectedMediaIndex=${selectedMediaIndex} selectedColorVariantId=${selectedColorVariantId} selectedColorOption=${selectedColorOption}`
    const quickShopHistory = getQuickShopHistoryProductsSelect(getState()) || []

    logUtil('updateQuickShopHistorySelectedMediaAction').debug(`${logPrefix} quickShopHistory=`, quickShopHistory)

    if (quickShopHistory?.length < 1) {
      logUtil('updateQuickShopHistorySelectedMediaAction').debug(`${logPrefix} [noop] no history`)
      return
    }

    const updates = {
      selectedMediaIndex,
      selectedColorOption,
      selectedVariantId: selectedColorVariantId
    }
    const lastQuickShopHistory = quickShopHistory[quickShopHistory.length - 1]

    const newQuickShopHistory = [
      ...quickShopHistory.slice(0, quickShopHistory.length - 1),
      {
        ...lastQuickShopHistory,
        ...updates
      }
    ]

    dispatch(
      updateQuickShopHistoryProductsAction(newQuickShopHistory)
    )

    logUtil('updateQuickShopHistorySelectedMediaAction').debug(`${logPrefix} [done] newQuickShopHistory=`, newQuickShopHistory)
  }
}

export default updateQuickShopHistorySelectedMediaAction
